import React from 'react';
import LOGO from '../../assets/LandingPage/Footer/opti_logo.svg';
import { Link } from 'react-router-dom';
import './Footer.css';
import useSafeNavigate from '../../hooks/useSafeNavigate';
import { FiLinkedin, FiMail } from 'react-icons/fi';
import scrollToElement from '../../utils/scrollToElement';

const quickAction = [
  { title: 'Home', link: '/#hero-section', sectionId: 'hero-section' },
  { title: 'Features', link: '/#why-choose-us-section', sectionId: 'why-choose-us-section' },
  { title: 'Contact us', link: '/contact-support' }
];

const aboutLinks = [
  { title: 'Support', link: '/contact-support' },
  { title: 'Terms & Conditions', link: '/terms-conditions' },
  { title: 'Privacy Policy', link: '/privacy-policy' },
  { title: 'Refund  policy', link: '/refund-cancellation' }
];

const icons = [
  {
    id: 1,
    icon: <FiLinkedin style={{fontSize: '24px'}} />,
    link: 'https://www.linkedin.com/company/simppwey-private-limited/',
  },
  {
    id: 2,
    icon: <FiMail style={{fontSize: '24px'}} />,
    link: 'mailto:support@optigrit.com',
  },
];

export default function Footer() {

  const navigate = useSafeNavigate();

  const handleNavClick = (info = {}) => {
    if(!Object.hasOwn(info, 'sectionId')) {
      navigate(info.link);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    navigate(info.link);

    scrollToElement(`#${info.sectionId}`);
  };

  return (
    <footer className='landing-footer' >
      <div className='flex flex-col' style={{ maxWidth: '1080px', gap: '40px', width: '100%', padding: '40px 20px', boxSizing: 'border-box' }} >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }} >
          <div className='img-container' style={{ maxWidth: '120px' }} >
            <img src={LOGO} alt="404" />
          </div>
          <p className='secondry-text' >
            Allyway Technologies Pvt Ltd.
          </p>
        </div>

        <div className='flex flex-wrap' style={{ gap: '80px', justifyContent: 'space-between' }} >
          <div className='flex flex-col' style={{ gap: '8px' }} >
            <h1 className='primary-text' >Contact Details</h1>
            <div className='flex flex-col' style={{ gap: '4px', opacity: 0.5 }}>
              <p>support@optigrit.com</p>
              <p>Call(Sales): +91-9878324029</p>
            </div>
          </div>

          <div className='flex flex-wrap' style={{ gap: '40px 80px' }} >
            <div className='flex flex-col' style={{ gap: '8px' }} >
              <h1 className='primary-text' >QUICK</h1>
              <div className='flex flex-col' style={{ gap: '4px' }}>
                {
                  quickAction.map(info => (
                    <p key={info.title} className='secondry-link' onClick={() => handleNavClick(info)} >{info.title}</p>
                  ))
                }
              </div>
            </div>

            <div className='flex flex-col gap-2' style={{ gap: '8px' }} >
              <h1 className='primary-text' >ABOUT</h1>
              <div className='flex flex-col' style={{ gap: '4px' }}>
                {
                  aboutLinks.map(({ title, link }) => (
                    <Link key={title} className='secondry-link' to={link} >{title}</Link>
                  ))
                }
              </div>
            </div>

            <div className='flex flex-col gap-2' style={{ gap: '8px' }} >
              <h1 className='primary-text' >CONNECT WITH US</h1>
              <div className='flex flex-wrap' style={{ gap: '4px', opacity: 0.5 }}>
                {
                  icons.map(({ id, icon, link }) => (
                    <a
                      href={link}
                      key={id}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="icons"
                    >
                      {icon}
                    </a>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr style={{ width: '100%', height: '1px', backgroundColor: 'rgb(255,255,255,0.8)' }} />

      <p style={{ textAlign: 'center', padding: '20px 40px' }} >
        © Copyright 2022 Optigrit, Inc. All rights reserved. Various trademarks held by their respective owners.
      </p>
    </footer>
  );
}